<main class="page-container__body">
    <div class="faq content-area-9">
        <div class="container">
            <div class="main-title text-center">
                <h1>Frequently Asked Questions</h1>
            </div>
            <div class="row">
                <div class="col-lg-10 offset-lg-1">
                    <div id="faq" class="faq-accordion">
                        <div class="card m-b-0">
                            <!--faq1-->
                            <div class="card-header">
                                <a class="card-title collapsed" data-toggle="collapse" data-parent="#faq" href="#collapse1" aria-expanded="false">
                                    How to Register ?
                                </a>
                            </div>
                            <div id="collapse1" class="card-block collapse show" style="">
                                <div class="p-text">
                                    <div class="col-md-4 col-xs-12">
                                        <div class="course_container">
                                            <figure>
                                                <a href="#" class="video-btn" data-toggle="modal" data-target=".bd-example-modal-lg" type="button" >
                                                    <img src="assets/img/screen1.PNG" width="800" height="533" class="img-responsive" alt="Image">
                                                    <img src="assets/img/play_icon.png" class="play_button" alt="play_icon" >
                                                    <div class="short_info"><i class="icon-clock-1"></i>0 hr 01 min 38 sec</div>
                                                </a>
                                            </figure>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!--faq2-->
                            <div class="card-header">
                                <a class="card-title collapsed" data-toggle="collapse" data-parent="#faq" href="#collapse2" aria-expanded="false">
                                    Payments 
                                </a>
                            </div>
                            <div id="collapse2" class="card-block collapse">
                                <div class="p-text">
                                    <p>
                                        <strong>
                                            Do I Have To Use A Credit Card?
                                        </strong>
                                    </p>
                                    <p>
                                        Yes, GovTow Auctions requires the use of a credit card in order to bid on vehicles and
                                        to
                                        pay
                                        for any auctions you win.
                                    </p>
                                    <p>
                                        <strong>
                                            I Have Not Won An Auction Yet. Why Do I Need To Have A Credit Card On File Just To
                                            Bid?
                                        </strong>
                                    </p>
                                    <p>
                                        GovTow Auctions automatically charges your credit card when you win an auction.
                                        Therefore,
                                        we
                                        need to have your credit card on file. This process allows for a smooth and convenient
                                        experience for both buyers and sellers
                                    </p>
                                    <p>
                                        <strong>
                                            I Won An Auction. When Do I Pay?
                                        </strong>
                                    </p>
                                    <p>
                                        GovTow Auctions automatically charges your credit card when you win an auction. No
                                        further
                                        action on your part is necessary.
                                    </p>
                                </div>
                            </div>
                            <!--faq3-->
                            <div class="card-header">
                                <a class="card-title collapsed" data-toggle="collapse" data-parent="#faq" href="#collapse3" aria-expanded="false">
                                    Payments Issues
                                </a>
                            </div>

                            <div id="collapse3" class="card-block collapse">
                                <div class="p-text">
                                    <p>
                                        <strong>
                                            I Got An Email Stating That My Credit Card Was Expiring And I Can No Longer Bid.
                                            What Do
                                            I
                                            Do?
                                        </strong>
                                    </p>
                                    <p>
                                        Because GovTow Auctions automatically charges your credit card when you win an auction,
                                        we
                                        need
                                        a valid credit card on file. Please update your credit card information in your user
                                        profile.
                                    </p>
                                    <p>
                                        <strong>
                                            My Credit Card Limit Is Less Than The Total Of All The Auctions That I Am Bidding
                                            On.
                                            Can I
                                            Back Out Of Specific Auctions If I Hit My Limit?
                                        </strong>
                                    </p>
                                    <p>
                                        No, please only bid on vehicles that you can pay for, and anticipate the possibility of
                                        winning
                                        all the auctions that you bid on. If possible, ask your provider for a higher limit, or
                                        change
                                        your payment details to a higher limit credit card.
                                    </p>
                                    <p>
                                        <strong>
                                            My Credit Card Was Declined. What Do I Do?
                                        </strong>
                                    </p>
                                    <p>
                                        After winning an auction, GovTow Auctions automatically charges your credit card. If the
                                        transaction is declined, we will attempt to contact you to request that you update your
                                        payment
                                        method or that you to contact your provider to authorize the transaction. Please take
                                        care
                                        of
                                        the issue within 15 minutes of the end of the auction or we reserve the right to award
                                        the
                                        auction to another bidder.
                                    </p>
                                    <p>
                                        Please note, having a valid, functioning credit card is the bidder’s responsibility even
                                        if
                                        GovTow Auctions is unable to notify you. The high bidder is not officially the winner
                                        until
                                        payment is made.
                                    </p>
                                </div>
                            </div>
                            <!--faq4-->
                            <div class="card-header bd-none">
                                <a class="card-title collapsed" data-toggle="collapse" data-parent="#faq" href="#collapse4" aria-expanded="false">
                                    Bidding
                                </a>
                            </div>
                            <div id="collapse4" class="card-block collapse" style="">
                                <div class="p-text">
                                    <p>
                                        <strong>
                                            How Do I Bid And Where Can I Bid?
                                        </strong>
                                    </p>
                                    <p>
                                        GovTow Auctions makes bidding easy. You can bid directly on the vehicle page where it
                                        shows
                                        “Enter max bid amount” and has a “Place Bid” button. You do not have to bid the minimum
                                        amount
                                        that the auction requires. Simply set the maximum price that you are willing to pay as
                                        your
                                        bid
                                        and click the “Place Bid” button. Confirm your bid by clicking “YES” on the confirmation
                                        pop-up.
                                        <br>
        
                                        You can also bid on the Current Bids and Favorites pages. As above, set the maximum
                                        price
                                        that
                                        you are willing to pay as your bid under Bid Amount, and then click the “Place Bid”
                                        button.
                                        Confirm your bid by clicking “YES” on the confirmation pop-up.<br>
        
                                        If someone else bids after you, the system will then automatically and incrementally bid
                                        on
                                        your
                                        behalf up to the amount that you have set, without any further action required from you.
                                    </p>
                                    <p>
                                        <strong>
                                            What Is The Reserve Price?
                                        </strong>
                                    </p>
                                    <p>
                                        This is the minimum price that the seller will allow a vehicle to sell for. If the
                                        reserve
                                        price
                                        is set higher than the highest bid, then no bidder automatically wins the vehicle.
                                        However,
                                        the
                                        seller reserves the right to lower the reserve price and/or award the highest bidder of
                                        the
                                        auction even if the reserve price is not met. <br>
                                        Keep bidding even if you think you will not make the reserve price! You could score a
                                        real
                                        deal
                                        if you’re the highest bidder and the seller accepts!
                                    </p>
                                    <p>
                                        <strong>
                                            I Bid On An Auction And I Was Outbid Instantly. How?
                                        </strong>
                                    </p>
                                    <p>
                                        Bidders can set a maximum price that they are willing to pay as their bid. The system
                                        will
                                        then
                                        automatically and incrementally bid on their behalf up to their maximum price. You were
                                        beaten
                                        by another user’s automatic bid. Raise your maximum price so that way you can still win!
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-body">
                <button type="button" class="close" data-dismiss="modal" (click)="closeVideo()" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>        
                  <!-- 16:9 aspect ratio -->
          <div class="embed-responsive embed-responsive-16by9">
            <video class="embed-responsive-item" allow="autoplay" id="video" allowscriptaccess="always" loop controls>
                <source src="assets/video/uri.mp4" type="video/mp4">
                <!-- <source src="assets/video/uri.ogg" type="video/ogg"> -->
            </video>
          </div>
                  
            </div>
          </div>
        </div>
    </div>
    <!-- <div class="container">
        <div class="page-header toptoscroll">
            <h1>Frequently Asked Questions</h1>
            <hr class="hr-highlight" />
        </div>
        
        <div class="row">
            <div class="col-xl-2 col-lg-2 col-md-4 col-xs-12">
                <div class="scrollspy-sidebar affix-top">
                    <div class="scrollspy-sidenav">
                        <ul class="nav faq-nav">
                            <li class="">
                                <a (click)="scrollToElement(register)" aria-label="Anchor">How To Register</a>
                            </li>
                            <li class="">
                                <a (click)="scrollToElement(payments)" aria-label="Anchor">Payments</a>
                            </li>
                            <li class="">
                                <a (click)="scrollToElement(paymentsIssues)" aria-label="Anchor">Payments Issues</a>
                            </li>
                            <li class="">
                                <a (click)="scrollToElement(bidding)" aria-label="Anchor">Bidding</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="col-xl-10 col-lg-10 col-md-10 col-xs-12">
                <div class="accordion" id="faqAccordion">

                    <div class="bd-callout bd-callout-danger" #register id="headingOne">
                        <h3 class="accordion" data-toggle="collapse" data-target="#register" aria-expanded="true">
                            How to Register ?
                        </h3>
                        
                        <div id="register" class="collapse show" aria-labelledby="headingOne" data-parent="#faqAccordion">
                            
                            <div class="s-border"></div>
                            <div class="m-border"></div>
                            <div class="col-md-4 col-xs-12">
                                <div class="course_container">
                                    <figure>
                                        <a href="#" class="video-btn" data-toggle="modal" data-target=".bd-example-modal-lg" type="button" >
                                            <img src="assets/img/screen1.PNG" width="800" height="533" class="img-responsive" alt="Image">
                                            <img src="assets/img/play_icon.png" class="play_button" alt="play_icon" >
                                            <div class="short_info"><i class="icon-clock-1"></i>0 hr 01 min 38 sec</div>
                                        </a>
                                    </figure>
                                    
                                </div>
                            </div>
                    </div>
                    </div>

                    <div class="bd-callout bd-callout-danger" #payments id="headingTwo">
                        <h3 class="accordion" data-toggle="collapse" data-target="#payments" aria-expanded="true">
                            Payments
                        </h3>
                        <div id="payments" class="collapse show" aria-labelledby="headingTwo"
                            data-parent="#faqAccordion">
                            <div class="s-border"></div>
                            <div class="m-border"></div>
                            <p>
                                <strong>
                                    Do I Have To Use A Credit Card?
                                </strong>
                            </p>
                            <p>
                                Yes, GovTow Auctions requires the use of a credit card in order to bid on vehicles and
                                to
                                pay
                                for any auctions you win.
                            </p>
                            <p>
                                <strong>
                                    I Have Not Won An Auction Yet. Why Do I Need To Have A Credit Card On File Just To
                                    Bid?
                                </strong>
                            </p>
                            <p>
                                GovTow Auctions automatically charges your credit card when you win an auction.
                                Therefore,
                                we
                                need to have your credit card on file. This process allows for a smooth and convenient
                                experience for both buyers and sellers
                            </p>
                            <p>
                                <strong>
                                    I Won An Auction. When Do I Pay?
                                </strong>
                            </p>
                            <p>
                                GovTow Auctions automatically charges your credit card when you win an auction. No
                                further
                                action on your part is necessary.
                            </p>
                        </div>
                    </div>

                    <div class="bd-callout bd-callout-danger" #paymentsIssues id="headingThree">
                        <h3 data-toggle="collapse" data-target="#paymentsIssues" aria-expanded="false">Payments Issues
                        </h3>
                        <div id="paymentsIssues" class="collapse" aria-labelledby="headingThree"
                            data-parent="#faqAccordion">
                            <div class="s-border"></div>
                            <div class="m-border"></div>
                            <p>
                                <strong>
                                    I Got An Email Stating That My Credit Card Was Expiring And I Can No Longer Bid.
                                    What Do I Do?
                                </strong>
                            </p>
                            <p>
                                Because GovTow Auctions automatically charges your credit card when you win an auction,
                                we
                                need
                                a valid credit card on file. Please update your credit card information in your user
                                profile.
                            </p>
                            <p>
                                <strong>
                                    My Credit Card Limit Is Less Than The Total Of All The Auctions That I Am Bidding
                                    On.
                                    Can I
                                    Back Out Of Specific Auctions If I Hit My Limit?
                                </strong>
                            </p>
                            <p>
                                No, please only bid on vehicles that you can pay for, and anticipate the possibility of
                                winning
                                all the auctions that you bid on. If possible, ask your provider for a higher limit, or
                                change
                                your payment details to a higher limit credit card.
                            </p>
                            <p>
                                <strong>
                                    My Credit Card Was Declined. What Do I Do?
                                </strong>
                            </p>
                            <p>
                                After winning an auction, GovTow Auctions automatically charges your credit card. If the
                                transaction is declined, we will attempt to contact you to request that you update your
                                payment
                                method or that you to contact your provider to authorize the transaction. Please take
                                care
                                of
                                the issue within 15 minutes of the end of the auction or we reserve the right to award
                                the
                                auction to another bidder.
                            </p>
                            <p>
                                Please note, having a valid, functioning credit card is the bidder’s responsibility even
                                if
                                GovTow Auctions is unable to notify you. The high bidder is not officially the winner
                                until
                                payment is made.
                            </p>
                        </div>
                    </div>

                    <div class="bd-callout bd-callout-danger" #bidding id="headingFour">
                        <h3 data-toggle="collapse" data-target="#bidding" aria-expanded="false">Bidding</h3>
                        <div id="bidding" class="collapse" aria-labelledby="headingFour" data-parent="#faqAccordion">
                            <div class="s-border"></div>
                            <div class="m-border"></div>
                            <p>
                                <strong>
                                    How Do I Bid And Where Can I Bid?
                                </strong>
                            </p>
                            <p>
                                GovTow Auctions makes bidding easy. You can bid directly on the vehicle page where it
                                shows
                                “Enter max bid amount” and has a “Place Bid” button. You do not have to bid the minimum
                                amount
                                that the auction requires. Simply set the maximum price that you are willing to pay as
                                your
                                bid
                                and click the “Place Bid” button. Confirm your bid by clicking “YES” on the confirmation
                                pop-up.
                                <br>

                                You can also bid on the Current Bids and Favorites pages. As above, set the maximum
                                price
                                that
                                you are willing to pay as your bid under Bid Amount, and then click the “Place Bid”
                                button.
                                Confirm your bid by clicking “YES” on the confirmation pop-up.<br>

                                If someone else bids after you, the system will then automatically and incrementally bid
                                on
                                your
                                behalf up to the amount that you have set, without any further action required from you.
                            </p>
                            <p>
                                <strong>
                                    What Is The Reserve Price?
                                </strong>
                            </p>
                            <p>
                                This is the minimum price that the seller will allow a vehicle to sell for. If the
                                reserve
                                price
                                is set higher than the highest bid, then no bidder automatically wins the vehicle.
                                However,
                                the
                                seller reserves the right to lower the reserve price and/or award the highest bidder of
                                the
                                auction even if the reserve price is not met. <br>
                                Keep bidding even if you think you will not make the reserve price! You could score a
                                real
                                deal
                                if you’re the highest bidder and the seller accepts!
                            </p>
                            <p>
                                <strong>
                                    I Bid On An Auction And I Was Outbid Instantly. How?
                                </strong>
                            </p>
                            <p>
                                Bidders can set a maximum price that they are willing to pay as their bid. The system
                                will
                                then
                                automatically and incrementally bid on their behalf up to their maximum price. You were
                                beaten
                                by another user’s automatic bid. Raise your maximum price so that way you can still win!
                            </p>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        
       

    </div> -->
</main>
